var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('v-layout', {
    staticStyle: {
      "gap": "4px"
    },
    attrs: {
      "column": ""
    }
  }, [!_vm.form.gift ? [_c('exchange-gifts', _vm._g(_vm._b({
    ref: "exchange-gifts",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm._v("선물하기")])])];
      }
    }], null, false, 1269097961)
  }, 'exchange-gifts', {
    amount: _vm.form.amount
  }, false), {
    exec: _vm.send
  }))] : [_c('gift-info', _vm._g(_vm._b({
    ref: "gift-info",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
            on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm._v("발송내역")])])];
      }
    }], null, false, 596590861)
  }, 'gift-info', {
    value: _vm.value,
    loading: _vm.loading
  }, false), {
    redo: _vm.redo,
    undo: _vm.undo
  }))]], 2) : _c('span', [_vm._v(" - ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }